import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header-component';
import { FooterComponent } from '../../shared/components/footer-component';

@Component({
  selector: 'app-common-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './common-layout.html'
})
export class CommonLayoutComponent {
  private route = inject(ActivatedRoute);

  homeRoute = '/login';

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.homeRoute = params.get('returnUrl') || '/login';
    });
  }
}
